(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[34359,40659,81066,75847,44709,40852,81243,74453,44954,40617],{

/***/ 78677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Wireframes; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./components/CaseStudiesCommon/utils/data.js
var data = __webpack_require__(27515);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(2664);
// EXTERNAL MODULE: ./redux/selectors/layout.js
var layout = __webpack_require__(19341);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/components/Wireframes/utils/herlpers.js
var DEFAULT_MOBILE_IMAGE_SIZE = 350;
var DEFAULT_IMAGE_SIZE = 500;
var IMAGE_SIZES = {
    "marketplace-for-clairvoyant-services": 541,
    fernwayer: {
        default: 478,
        secondSectionView: 650
    },
    fireaway: {
        default: 425
    },
    dindon: {
        default: 440
    },
    "seven-pm-thursday": {
        default: 478
    },
    stickerbox: {
        default: 480
    },
    fairy: {
        default: 478
    },
    "open-sense": {
        default: 440
    },
    "drive-focus": {
        default: 440
    },
    tell: {
        default: 478
    },
    "travel-trivia": {
        default: 478
    },
    "cash-chat": {
        default: 478
    },
    beautonomy: 600,
    meateater: {
        default: 470
    },
    "separate-us": {
        default: 440
    },
    "fintech-app-for-credit-score": {
        default: 480
    },
    ubichat: {
        default: 500
    },
    telemojo: {
        default: 440
    },
    famlicious: 478,
    bionorica: {
        default: 500
    },
    humankind: {
        default: 515
    },
    blackbird: {
        default: 480
    },
    "software-for-mri-interpretation": 630,
    "fusion-markets": {
        default: 440
    },
    "machine-learning-in-real-estate": {
        sixthSectionView: 480
    },
    "mobile-bank-application": {
        default: 586
    },
    "forex-trading-platform": {
        default: 560
    },
    "kitchen-equipment-customizer": {
        default: 622
    },
    "mobile-music-app": {
        firstSectionView: 600,
        secondSectionView: 100
    },
    "medical-software-for-musculoskeletal-rehabilitation": {
        default: 600
    },
    "ai-software-development-services": {
        firstSectionView: 208
    },
    "ai-documentation-processing": {
        firstSectionView: 522
    }
};
var MOBILE_IMAGE_SIZES = {
    fireaway: {
        default: 250
    },
    tell: {
        default: 350
    },
    "separate-us": {
        default: 180
    },
    "drive-focus": {
        default: 220
    },
    ubichat: {
        default: 220
    },
    "marketplace-for-clairvoyant-services": {
        default: 206
    },
    "fusion-markets": {
        default: 206
    },
    telemojo: {
        default: 206
    },
    blackbird: {
        default: 350
    },
    dindon: {
        default: 181
    },
    humankind: {
        default: 181
    },
    "machine-learning-in-real-estate": {
        sixthSectionView: 240
    },
    "mobile-bank-application": {
        default: 550
    },
    "forex-trading-platform": {
        default: 228
    },
    meateater: {
        default: 211
    },
    "kitchen-equipment-customizer": {
        default: 206
    },
    "mobile-music-app": {
        firstSectionView: 600,
        secondSectionView: 40
    },
    "medical-software-for-musculoskeletal-rehabilitation": {
        default: 320
    },
    "ai-software-development-services": {
        firstSectionView: 188
    },
    "ai-documentation-processing": {
        firstSectionView: 206
    }
};

;// CONCATENATED MODULE: ./UI/components/Wireframes/utils/useWireframes.js






var useWireframes = function(param) {
    var images = param.images, type = param.type, view = param.view;
    var isMobileResolution = (0,es.useSelector)(layout/* selectIsMobile */.eD);
    var wireframeImages = images === null || images === void 0 ? void 0 : images.map(function(image) {
        var ref, ref1;
        var imageData = (0,helper/* getImage */.gJ)(image);
        var height = isMobileResolution ? ((ref = MOBILE_IMAGE_SIZES[type]) === null || ref === void 0 ? void 0 : ref[view || "default"]) || DEFAULT_MOBILE_IMAGE_SIZE : ((ref1 = IMAGE_SIZES[type]) === null || ref1 === void 0 ? void 0 : ref1[view || "default"]) || DEFAULT_IMAGE_SIZE;
        var scale = height / imageData.height;
        var width = Math.trunc(imageData.width * scale);
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageData), {
            width: width,
            height: height
        });
    });
    return {
        type: type,
        images: images,
        wireframeImages: wireframeImages,
        isMobileResolution: isMobileResolution
    };
};

// EXTERNAL MODULE: ./UI/components/Wireframes/styles.module.scss
var styles_module = __webpack_require__(5665);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Wireframes/index.jsx










var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var Wireframe = function(props) {
    var ref = useWireframes(props), type = ref.type, wireframeImages = ref.wireframeImages;
    if (!wireframeImages) {
        return null;
    }
    return wireframeImages === null || wireframeImages === void 0 ? void 0 : wireframeImages.map(function(param) {
        var url = param.url, alt = param.alt, height = param.height, width = param.width;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            delay: 100
        }, data/* ANIMATION_CASE_STUDY_PROPS */.e), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((styles_module_default())[type], (styles_module_default()).container),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                        src: url,
                        alt: alt,
                        layout: "responsive",
                        style: {
                            minWidth: "".concat(width, "px"),
                            height: "".concat(height, "px")
                        },
                        width: width,
                        height: height,
                        containerClasses: (styles_module_default()).animatedContainer,
                        className: (styles_module_default()).image,
                        unoptimized: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                        src: url,
                        alt: alt,
                        layout: "responsive",
                        style: {
                            minWidth: "".concat(width, "px"),
                            height: "".concat(height, "px")
                        },
                        width: width,
                        height: height,
                        containerClasses: (styles_module_default()).animatedContainer,
                        className: (styles_module_default()).image,
                        unoptimized: true
                    })
                ]
            })
        }), url);
    });
};
Wireframe.propTypes = {
    images: prop_types_default().arrayOf(prop_types_default().instanceOf(Object)).isRequired,
    type: (prop_types_default()).string.isRequired,
    view: (prop_types_default()).string
};
/* harmony default export */ var Wireframes = (Wireframe);


/***/ }),

/***/ 75033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_ChallengesAndSolutionsWithWireframes; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/components/ChallengesAndSolutions/index.jsx + 5 modules
var ChallengesAndSolutions = __webpack_require__(59870);
// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx
var SectionTitle = __webpack_require__(15805);
// EXTERNAL MODULE: ./UI/components/Wireframes/index.jsx + 2 modules
var Wireframes = __webpack_require__(78677);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/sections/ChallengesAndSolutionsWithWireframes/utils/useChallengesAndSolutionsWithWireframes.js

var useChallengesAndSolutionsWithWireframes = function(param) {
    var data = param.data, type = param.type;
    var title = data.title, subtitle = data.subtitle, description = data.description, view = data.view, images = data.images, background = data.background;
    return {
        data: data,
        type: type,
        view: view,
        images: images,
        title: title,
        subtitle: subtitle,
        description: description,
        background: (0,helper/* getImage */.gJ)(background)
    };
};

// EXTERNAL MODULE: ./UI/sections/ChallengesAndSolutionsWithWireframes/styles.module.scss
var styles_module = __webpack_require__(96817);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/sections/ChallengesAndSolutionsWithWireframes/index.jsx










var ChallengesAndSolutionsWithWireframes = function(props) {
    var ref = useChallengesAndSolutionsWithWireframes(props), data = ref.data, type = ref.type, view = ref.view, title = ref.title, images = ref.images, subtitle = ref.subtitle, description = ref.description, background = ref.background;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: classnames_default()((styles_module_default())[type], (styles_module_default())[view], (styles_module_default()).container, (0,_define_property/* default */.Z)({}, (styles_module_default()).challengesWithoutImage, images === null || images === void 0 ? void 0 : images.length)),
        children: [
            background && /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                src: background.url,
                className: (styles_module_default()).background
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                type: type,
                title: title,
                subtitle: subtitle,
                description: description,
                className: (styles_module_default()).titleStyle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChallengesAndSolutions/* default */.Z, {
                data: data,
                type: type,
                view: view
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Wireframes/* default */.Z, {
                images: images,
                type: type,
                view: view
            })
        ]
    });
};
ChallengesAndSolutions/* default.defaultProps */.Z.defaultProps = {
    type: ""
};
ChallengesAndSolutions/* default.propTypes */.Z.propTypes = {
    data: prop_types_default().instanceOf(Object).isRequired,
    type: (prop_types_default()).string
};
/* harmony default export */ var sections_ChallengesAndSolutionsWithWireframes = (ChallengesAndSolutionsWithWireframes);


/***/ }),

/***/ 40659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Common_LinkWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./utils/ga.js
var ga = __webpack_require__(48114);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/helpers/index.js
var isAbsoluteUrl = function(path) {
    try {
        var _ = new URL(path);
        return true;
    } catch (e) {
        return false;
    }
};

// EXTERNAL MODULE: ./components/Common/LinkWrapper/styles.module.scss
var styles_module = __webpack_require__(81098);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/index.jsx










var LinkWrapper = function(param) {
    var path = param.path, className = param.className, children = param.children, googleAnalyticProps = param.googleAnalyticProps, isSocialLink = param.isSocialLink, onClick = param.onClick;
    var isAbsoluteLink = (0,react.useMemo)(function() {
        return isAbsoluteUrl(path);
    }, [
        path
    ]);
    var isLocalLink = !isAbsoluteLink || path.includes(constants/* CUSTOM_DOMAIN */.zq);
    if (!path) {
        return children;
    }
    var target = !isLocalLink ? "_blank" : undefined;
    var rel = isSocialLink || isLocalLink ? undefined : "noopener noreferrer nofollow";
    var href = !isAbsoluteLink && path[0] !== "/" ? "/".concat(path) : path;
    var handleOnClick = function(e) {
        if (!isEmpty_default()(googleAnalyticProps)) {
            var category = googleAnalyticProps.category, action = googleAnalyticProps.action, label = googleAnalyticProps.label, data = googleAnalyticProps.data;
            ga/* default.trackEvent */.Z.trackEvent(category || data, action || data, label || data);
        }
        onClick(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        /* TODO: if you need to instantly open pages via links in the navigation,
      you can remove this code to enable link page generation and loading. However, performance will be degraded
      more: https://nextjs.org/docs/api-reference/next/link */ prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: classnames_default()((styles_module_default()).link, className),
            onClick: handleOnClick,
            target: target,
            rel: rel,
            children: children
        })
    });
};
LinkWrapper.defaultProps = {
    path: null,
    className: null,
    googleAnalyticProps: {},
    children: null,
    isSocialLink: false,
    onClick: function() {}
};
LinkWrapper.propTypes = {
    path: (prop_types_default()).string,
    className: (prop_types_default()).string,
    googleAnalyticProps: prop_types_default().instanceOf(Object),
    children: (prop_types_default()).node,
    isSocialLink: (prop_types_default()).bool,
    onClick: (prop_types_default()).func
};
/* harmony default export */ var Common_LinkWrapper = (LinkWrapper);


/***/ }),

/***/ 5665:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__ZQHkg","animatedContainer":"styles_animatedContainer__WYfJB","image-scroll":"styles_image-scroll__pUNL8","stickerbox":"styles_stickerbox__y5DTR","image":"styles_image__bGCuA","fireaway":"styles_fireaway__l2P6I","seven-pm-thursday":"styles_seven-pm-thursday___Cl7g","open-sense":"styles_open-sense__Yklmv","drive-focus":"styles_drive-focus__12y7P","separate-us":"styles_separate-us__TLw4a","ubichat":"styles_ubichat__jbYPB","bionorica":"styles_bionorica__SM7Vw","fusion-markets":"styles_fusion-markets__H5xo9","beautonomy":"styles_beautonomy__ymseQ","meateater":"styles_meateater__qWYXE","mobile-music-app":"styles_mobile-music-app__hRFB5","blinking":"styles_blinking__7Ds4t","swing":"styles_swing__rXIHm","animateborder":"styles_animateborder__DhniH","animateborder-overlay":"styles_animateborder-overlay__8FnUW","animatecircle":"styles_animatecircle__kwr9O","animatedot":"styles_animatedot__9xDD6","animStar":"styles_animStar__EbuN6","hideText":"styles_hideText__hmhu8","spin":"styles_spin__8Cp8N","outOfTransparencyDesktop":"styles_outOfTransparencyDesktop__vtAMq","outOfTransparencyMobile":"styles_outOfTransparencyMobile__lpcr9","appearance":"styles_appearance__bMdbB","appearanceFromBelow":"styles_appearanceFromBelow__FL2aE","flicker":"styles_flicker__IS6Zf","vibrate1":"styles_vibrate1__jFR_O","rocket":"styles_rocket__zssUG","burgerItem1":"styles_burgerItem1__fTxlS","burgerItem2":"styles_burgerItem2__O_WVU","burgerItem3":"styles_burgerItem3__nrRQL","burgerItem1Reverse":"styles_burgerItem1Reverse__UKx57","burgerItem2Reverse":"styles_burgerItem2Reverse__IOcVP","burgerItem3Reverse":"styles_burgerItem3Reverse__O0X_q","arrow-down":"styles_arrow-down__7dLP_","image-scroll-reverse":"styles_image-scroll-reverse__Lo_CU","stickerbox-pointer-move":"styles_stickerbox-pointer-move__Un_to","hide-image":"styles_hide-image__bPthP","stickerbox-pointer-second":"styles_stickerbox-pointer-second__Yn3ZV","stickerbox-pointer-third":"styles_stickerbox-pointer-third__OBnx_","cedar-bounce":"styles_cedar-bounce__so6an"};

/***/ }),

/***/ 96817:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__g2jNb","titleStyle":"styles_titleStyle__1xWU3","challengesWithoutImage":"styles_challengesWithoutImage__ftegU","background":"styles_background__b4ZOj","stickerbox":"styles_stickerbox___vqmt","fireaway":"styles_fireaway__uAL4Y","seven-pm-thursday":"styles_seven-pm-thursday__wImHF","secondSectionView":"styles_secondSectionView__3x3lS","fernwayer":"styles_fernwayer__GdSLA","firstSectionView":"styles_firstSectionView__xKq1X","drive-focus":"styles_drive-focus__oXk5_","hotel-data-cloud":"styles_hotel-data-cloud__Jykxh","open-sense":"styles_open-sense__Nhh5x","separate-us":"styles_separate-us__FoUVd","famlicious":"styles_famlicious__Mmjvn","natp":"styles_natp__OBPGs","travel-trivia":"styles_travel-trivia__w4e6s","tell":"styles_tell__jqWkR","ubichat":"styles_ubichat__r2EaY","writer-chrome-extension":"styles_writer-chrome-extension__l0XR0","meateater":"styles_meateater__wewJg","bionorica":"styles_bionorica__TrXpE","marketplace-for-clairvoyant-services":"styles_marketplace-for-clairvoyant-services__M2aah","fusion-markets":"styles_fusion-markets__UqxQG","beautonomy":"styles_beautonomy__TQeWe","telemojo":"styles_telemojo__iI_Yc","blackbird":"styles_blackbird__eTfvi","fintech-app-for-credit-score":"styles_fintech-app-for-credit-score__aixTi","smartcenter":"styles_smartcenter__RXrPq","dindon":"styles_dindon__w2g8_","humankind":"styles_humankind__zhe_Q","cinnabar":"styles_cinnabar__Vnp1h","machine-learning-in-real-estate":"styles_machine-learning-in-real-estate__kVELD","thirdSectionView":"styles_thirdSectionView__6Z__W","mobile-bank-application":"styles_mobile-bank-application___ZV2H","fifthSectionView":"styles_fifthSectionView__yy5Q_","software-for-mri-interpretation":"styles_software-for-mri-interpretation__GW0D_","cedar-valley-farms":"styles_cedar-valley-farms__zLRGW","mobile-budgeting-app":"styles_mobile-budgeting-app__kXSnO","forex-trading-platform":"styles_forex-trading-platform__W3fFN","why-us":"styles_why-us__jU_9K","crowdfunding-platform":"styles_crowdfunding-platform__f9dy5","analytics-for-carbon-tracking":"styles_analytics-for-carbon-tracking__Mom4k","cctv-footage-analytics":"styles_cctv-footage-analytics__9fk73","web-chat-for-mediums":"styles_web-chat-for-mediums__rAHso","web-p2p-lending-platform":"styles_web-p2p-lending-platform__W7_mP","kitchen-equipment-customizer":"styles_kitchen-equipment-customizer__b6_LP","clairvoyant-directory-upgrade":"styles_clairvoyant-directory-upgrade__zockq","digital-wallet-for-ios":"styles_digital-wallet-for-ios__Ka7d7","enterprise-resource-planning-system":"styles_enterprise-resource-planning-system__zui8a","ai-documentation-processing":"styles_ai-documentation-processing__h_PlQ","ai-mobile-cooking-app":"styles_ai-mobile-cooking-app__dMn8v","ai-based-travel-planner":"styles_ai-based-travel-planner___4KXh","computer-vision-for-aras":"styles_computer-vision-for-aras__vnaWy","penetration-testing-for-healthtech-company":"styles_penetration-testing-for-healthtech-company__psuEF","pen-testing-for-uk-web-dev-company":"styles_pen-testing-for-uk-web-dev-company__VWefh","pen-tests-ai":"styles_pen-tests-ai__DRLBO","web-logistics-platform":"styles_web-logistics-platform__L_Mat","contentContainer":"styles_contentContainer__TjiuR","ai-feedback-analysis":"styles_ai-feedback-analysis__VlmCv","ai-for-edtech":"styles_ai-for-edtech__uZ8EO","ai-reporting-assistant":"styles_ai-reporting-assistant__gGjP_","llm-for-insurtech-saas":"styles_llm-for-insurtech-saas__CcKEh","feedback-insight-engine":"styles_feedback-insight-engine__qQCVc","ai-voice-assistant-for-e-learning":"styles_ai-voice-assistant-for-e-learning__6gdtm","ai-assistant-for-chronic-patients":"styles_ai-assistant-for-chronic-patients__piIqA","ai-warehouse-agent":"styles_ai-warehouse-agent__AueVZ","rag-contract-intelligence-platform":"styles_rag-contract-intelligence-platform__1x_wZ","influx":"styles_influx___L5Dv","futurepay":"styles_futurepay__v2InA","commod":"styles_commod__Yg7Pt"};

/***/ }),

/***/ 81098:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__MXUD5"};

/***/ })

}]);